import { render, staticRenderFns } from "./serviceSubscriptDc.vue?vue&type=template&id=040af1b2&scoped=true"
import script from "./serviceSubscriptDc.vue?vue&type=script&lang=js"
export * from "./serviceSubscriptDc.vue?vue&type=script&lang=js"
import style0 from "./serviceSubscriptDc.vue?vue&type=style&index=0&id=040af1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040af1b2",
  null
  
)

export default component.exports